import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    subscribers: {
      name: "Liste d'emails |||| Liste d'emails",
    },
    feature_cohorts: {
      name: "Cohortes de fonctionnalités |||| Cohortes de fonctionnalités",
    },
    feature_cohort_members: {
      name: "Membre de cohorte |||| Membres de cohorte",
    },
    agencies: {
      name: "Agence |||| Agences",
    },
    agency_members: {
      name: "Membre d'agence |||| Membres d'agence",
    },
    agency_portal_users: {
      name: "Utilisateur du portail |||| Utilisateurs du portail",
    },
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Taille",
        tax_identifier: "Identifiant fiscal",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Responsable de compte",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} affaire |||| %{smart_count} affaires",
      sizes: {
        one_employee: "1 employé",
        two_to_nine_employees: "2-9 employés",
        ten_to_forty_nine_employees: "10-49 employés",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employés",
        two_hundred_fifty_or_more_employees: "250 employés ou plus",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
      filters: {
        only_mine: "Seulement les entreprises que je gère",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        last_echo_at: "Dernier Echo demarre",
        average_rating: "Etoiles moyennes",
        use_count: "Utilisations",
        completed_echo_count: "Echos termines",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        phone_country_iso2: "Pays",
        phone_country_name: "Pays",
        phone_continent_code: "Continent",
        phone_continent_name: "Continent",
        phone_geo_status: "Geographie du telephone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      broadcast: {
        action: "Diffusion",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
        button: "Importer un fichier CSV",
        complete:
          "Import des contacts terminé. %{importCount} contacts importés, %{errorCount} erreurs",
        progress:
          "%{importCount} / %{rowCount} contacts importés, avec %{errorCount} erreurs.",
        error:
          "Échec de l'importation de ce fichier. Veuillez vous assurer que vous avez fourni un fichier CSV valide.",
        imported: "Importé",
        remaining_time: "Temps restant estimé :",
        running: "L'import est en cours, merci de ne pas fermer cet onglet.",
        sample_download: "Télécharger un exemple CSV",
        sample_hint:
          "Voici un exemple de fichier CSV que vous pouvez utiliser comme modèle",
        stop: "Arrêter l'importation",
        csv_file: "Fichier CSV",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      metrics: {
        uses: "%{smart_count} utilisation |||| %{smart_count} utilisations",
        completed:
          "%{smart_count} Echo termine |||| %{smart_count} Echos termines",
        average_rating: "%{rating} etoiles",
        unrated: "Sans note",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        noop: "Les contacts sélectionnés ont déjà cette étiquette",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        geography: "Geographie",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    whatsapp_templates: {
      name: "Modele WhatsApp |||| Modeles WhatsApp",
      forcedCaseName: "Modele WhatsApp",
    },
    whatsapp_broadcasts: {
      name: "Diffusion WhatsApp |||| Diffusions WhatsApp",
      forcedCaseName: "Diffusion WhatsApp",
    },
    tepone_codes: {
      name: "Te Pone |||| Te Pone",
      forcedCaseName: "Te Pone",
    },
    echoflicks_video_sessions: {
      name: "Session video |||| Sessions video",
      forcedCaseName: "Session video",
      fields: {
        movie_title: "Titre du film",
        script_title: "Titre du script",
        contact_name: "Contact",
        whatsapp_user_id: "ID WhatsApp",
        session_id: "ID de session",
        workload_id: "ID de workload",
        status: "Statut",
        source_confidence: "Confiance",
        media_count: "Nombre de medias",
        uploaded_media_count: "Medias envoyes",
        rating: "Note",
        display_date: "Date",
      },
      empty:
        "Aucune session video trouvee. Lancez l'import local Echoflicks pour charger l'export media.",
    },
    echoflicks_echoes: {
      name: "Echo |||| Echoes",
      forcedCaseName: "Echo",
      fields: {
        movie_title: "Titre de l'echo",
        script_title: "Titre du script",
        contact_name: "Contact",
        whatsapp_user_id: "ID WhatsApp",
        session_id: "ID de session",
        workload_id: "ID de workload",
        status: "Statut",
        source_confidence: "Confiance",
        media_count: "Nombre de medias",
        uploaded_media_count: "Medias envoyes",
        rating: "Note",
        display_date: "Date",
      },
      empty:
        "Aucun echo trouve. Lancez l'import local Echoflicks pour charger les videos terminees.",
    },
    deals: {
      name: "Affaire |||| Affaires",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        category: "Catégorie",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
      },
      action: {
        back_to_deal: "Retour à l'affaire",
        create: "Créer une affaire",
        new: "Nouvelle affaire",
      },
      field_categories: {
        misc: "Divers",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : affaire non archivée",
        list_title: "Affaires archivées",
        success: "Affaire archivée",
        title: "Affaire archivée",
        view: "Afficher les affaires archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : affaire non désarchivée",
        success: "Affaire désarchivée",
      },
      updated: "Affaire mise à jour",
      empty: {
        before_create: "avant de créer une affaire.",
        description: "Il semble que votre liste d'affaires soit vide.",
        title: "Aucune affaire trouvée",
      },
      invalid_date: "Date invalide",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Affaire",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
    },
    sales: {
      name: "Utilisateur |||| Utilisateurs",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        administrator: "Admin",
        disabled: "Désactivé",
        blog_role: "Rôle blog",
      },
      blog_roles: {
        none: "Aucun",
        editor: "Éditeur (brouillons)",
        publisher: "Publication (brouillons et mise en ligne)",
      },
      create: {
        error:
          "Une erreur s'est produite lors de la création de l'utilisateur.",
        success:
          "Utilisateur créé. Ils recevront prochainement un email pour définir leur mot de passe.",
        title: "Créer un nouvel utilisateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Utilisateur mis à jour avec succès",
        title: "Modifier %{name}",
      },
      action: {
        new: "Nouvel utilisateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Description",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporté à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      updated: "Tâche mise à jour",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur Echoflicks CRM",
    },
    common: {
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
    },
    whatsapp: {
      action: "Envoyer WhatsApp",
      aside_title: "WhatsApp",
      opt_in_label: "Consentement marketing",
      opt_in: {
        approved: "Accepté",
        denied: "Refusé",
        unknown: "Inconnu",
      },
      stopped: "Arrêté",
      nav: "Diffusions",
      block_reasons: {
        contact_not_found:
          "Ce contact n'est pas disponible dans le tableau WhatsApp live.",
        freeform_window_expired:
          "La fenetre de service WhatsApp de 24 heures est fermee. Utilisez un modele approuve.",
        local_whatsapp_function_not_configured:
          "L'envoi WhatsApp n'est pas configure pour le mode Supabase local.",
        missing_whatsapp_user_id:
          "Ce contact n'est pas lie a un utilisateur WhatsApp.",
        no_recent_inbound_message:
          "Les messages libres necessitent un message WhatsApp entrant recent.",
        opted_out: "Ce contact s'est desabonne des messages WhatsApp.",
        unknown:
          "Ce contact ne peut pas recevoir de message WhatsApp libre maintenant.",
      },
      description:
        "Composer et envoyer un message WhatsApp sortant a ce contact.",
      error: "Echec du message WhatsApp",
      freeform_available: "Message libre disponible",
      freeform_mode: "Libre",
      marketing_opted_out_hint:
        "A refuse le marketing : diffusions et modeles restent desactives, mais les reponses libres sont autorisees tant que la fenetre de 24 heures est ouverte.",
      loading: "Verification WhatsApp",
      no_messages: "Aucun message WhatsApp sortant",
      placeholder: "Ecrivez une reponse WhatsApp...",
      recent_messages: "Messages sortants recents",
      requires_template_error:
        "Les messages WhatsApp libres necessitent une fenetre de service active de 24 heures.",
      send: "Envoyer",
      sending: "Envoi...",
      sent: "Message WhatsApp accepte",
      template: "Modele",
      template_mode: "Modele",
      template_required: "Modele requis",
      title: "Envoyer un message WhatsApp",
      timeline_empty: "Aucun message de conversation WhatsApp",
      timeline_error: "Echec du chargement de l'historique",
      timeline_loading: "Chargement de la conversation...",
      timeline_title: "Conversation WhatsApp",
      open_in_inbox: "Ouvrir dans Felix Inbox",
      window_expires: "La fenetre libre expire %{time}",
      inbox: {
        nav: "Boite de reception",
        title: "Boite de reception",
        description:
          "Clients dont le dernier message WhatsApp n'a pas pu etre traite par Felix. Prenez la conversation, repondez depuis le chat et elle se resout d'elle-meme.",
        tabs: {
          needs_reply: "A repondre",
          claimed: "Prises en charge",
          resolved: "Resolues",
        },
        empty: {
          needs_reply: "Personne n'attend de reponse pour le moment.",
          claimed: "Aucune conversation prise en charge.",
          resolved: "Rien de resolu pour l'instant.",
        },
        loading: "Chargement de la boite de reception...",
        error: "Impossible de charger la boite de reception",
        load_more: "Charger plus",
        showing: "%{count} sur %{total}",
        oldest_waiting: "plus ancienne attente %{time}",
        columns: {
          contact: "Contact",
          reason: "Motif",
          waiting: "Attente",
          window: "Fenetre",
          owner: "Responsable",
          actions: "Actions",
        },
        messages_count: "%{smart_count} message |||| %{smart_count} messages",
        claimed_by: "Pris en charge par %{name}",
        resolved_by: "Resolu par %{name}",
        unassigned: "Non attribue",
        window_open: "Libre encore %{time}",
        window_closed: "Modele requis",
        window_unknown: "Aucun message entrant",
        priority: {
          high: "Priorite haute",
          normal: "Priorite normale",
          low: "Priorite basse",
        },
        reason_unknown: "Besoin d'un humain",
        actions: {
          claim: "Prendre",
          resolve: "Resoudre",
          reopen: "Rouvrir",
          open_chat: "Ouvrir le chat",
          open_echo: "Ouvrir l'Echo",
          claim_done: "Conversation prise en charge",
          resolve_done: "Conversation resolue",
          reopen_done: "Conversation rouverte",
          claim_hint:
            "Met Felix en pause pour ce contact sur WhatsApp. Felix reprend quand vous liberez ou resolvez, ou quand la prise en charge expire faute de reponse de l'equipe.",
          release: "Liberer",
          release_hint: "Rendre ce contact a Felix et a la file.",
          release_done: "Libere. Felix repond de nouveau a ce contact.",
          release_confirm:
            "Liberer la prise en charge de %{name} ? Felix repondra de nouveau a ce contact.",
        },
        web_stall: {
          felix: "🌐 Echo web · entretien Felix bloque",
          render: "🌐 Echo web · rendu bloque",
          unknown: "🌐 Echo web bloque",
        },
        banner: {
          needs_reply: "Felix a besoin d'aide sur cette conversation",
          claimed: "Prise en charge par %{name}",
          waiting: "en attente %{time}",
          messages:
            "%{smart_count} message sans reponse |||| %{smart_count} messages sans reponse",
        },
        composer: {
          placeholder:
            "Repondre sur WhatsApp (Entree pour envoyer, Maj+Entree pour un saut de ligne)",
          send: "Envoyer",
          send_template: "Envoyer un modele",
          keep_open: "Garder ouverte",
          keep_open_hint:
            "L'envoi resout normalement la conversation. Cochez pour la garder ouverte.",
          sender: "Expediteur",
          checking: "Verification de la fenetre WhatsApp...",
          blocked: "Les reponses libres sont bloquees",
          no_sender: "Aucun expediteur WhatsApp verifie n'est disponible.",
        },
        load_older: "Charger les messages precedents",
        loading_older: "Chargement...",
        capability: {
          unavailable: "Boite de reception indisponible",
          disabled:
            "L'API dashboard connectee n'annonce pas la boite de reception client.",
        },
        filter: {
          category: "Boite de reception",
          needs_reply: "A repondre",
        },
      },
      capabilities: {
        analytics_disabled:
          "L'API dashboard connectee n'annonce pas le support des analyses de diffusion WhatsApp.",
        analytics_unavailable: "Analyses de diffusion indisponibles",
        broadcasts_disabled:
          "L'API dashboard connectee n'annonce pas le support des diffusions WhatsApp.",
        broadcasts_unavailable: "Diffusions indisponibles",
        media_disabled:
          "L'envoi de medias de modele n'est pas active dans cet environnement.",
        library_disabled:
          "L'API dashboard n'est pas liee a AWS End User Messaging Social pour la bibliotheque de modeles Meta.",
        library_unavailable: "Bibliotheque de modeles indisponible",
        sync_disabled:
          "L'API dashboard est joignable, mais la synchronisation WABA n'est pas configuree.",
        sync_unavailable: "Synchronisation Meta indisponible",
        templates_disabled:
          "L'API dashboard connectee n'annonce pas le support des modeles WhatsApp.",
        templates_unavailable: "Modeles indisponibles",
        worker_disabled:
          "Le worker de diffusion n'est pas active. Les envois peuvent necessiter une reprise manuelle.",
        worker_unavailable: "Worker de diffusion indisponible",
      },
      buttons: {
        use_suggested: "Libelles suggeres",
        preset_create: "Felix demarre un nouvel Echo",
        preset_create_command:
          "Felix demarre un nouvel Echo (la barre oblique est facultative)",
        preset_stop: "Felix desabonne ce contact des promotions",
        intent_create: "Felix demarrera un nouvel Echo si on appuie ici.",
        intent_stop: "Felix desabonnera le contact des promotions.",
        intent_text_only:
          "Felix comprend generalement ce libelle, mais pas sur toutes les voies de livraison. Choisissez un libelle suggere pour en etre certain.",
        intent_callback_only:
          "Felix ne comprendra souvent PAS ce libelle : les appuis arrivent normalement en texte brut, ce que cette formulation ne couvre pas. Choisissez un libelle suggere.",
        intent_unrecognized:
          'Felix ne reconnaitra pas ce libelle. Un appui renverra le contact vers la reponse "je n\'ai pas bien compris". Choisissez un libelle suggere, ou gardez un bouton URL.',
      },
      templates: {
        actions: "Actions",
        appeal: "Note d'appel",
        appeal_placeholder:
          "Ce qui a change et pourquoi le modele doit etre approuve",
        appeal_saved: "Note d'appel enregistree",
        appeal_title: "Rejet du modele",
        body: "Corps",
        category: "Categorie",
        empty: "Aucun modele WhatsApp",
        footer: "Pied",
        header: "En-tete",
        header_example: "Exemple d'en-tete",
        header_text: "Texte d'en-tete",
        language: "Langue",
        library: "Bibliotheque",
        library_empty: "Aucun modele de bibliotheque trouve",
        library_imported: "Modele importe depuis la bibliotheque",
        name: "Nom",
        my_templates: "Mes modeles",
        new: "Nouveau modele",
        policy_note:
          "Les modeles approuves peuvent etre utilises hors de la fenetre de service de 24 heures.",
        policy_title: "Validation des modeles",
        quality: "Qualite",
        body_example: "Exemple pour {{%{placeholder}}}",
        add_contact_number: "Ajouter le numero de contact",
        add_learn_more: "Ajouter le lien en savoir plus",
        add_security: "Ajouter la recommandation securite",
        add_tracking: "Ajouter le lien de suivi",
        button_inputs: "Parametres des boutons",
        button_no_inputs: "Aucun parametre requis pour ce bouton.",
        button_phone: "Numero de telephone",
        button_quick_reply: "Reponse rapide",
        button_text: "Texte du bouton",
        button_type: "Type",
        button_url: "URL du bouton",
        button_url_cta: "Site web",
        code_expiration: "Expiration du code en minutes",
        duplicate_name: "Ce nom de modele existe deja",
        duplicate_name_help:
          "Choisissez un autre nom. Les noms de modeles WhatsApp sont uniques par langue dans le WABA.",
        import: "Importer",
        import_history: "Historique d'import",
        import_history_empty: "Aucun import de modele",
        import_synced: "Statut d'import synchronise",
        imported_from: "Importe depuis %{name}",
        imported_from_label: "Importe depuis",
        import_title: "Importer un modele de bibliotheque",
        operator: "Operateur",
        operator_missing: "Identite operateur manquante",
        otp_type: "Type OTP",
        preview: "Apercu",
        preview_empty_body: "Apercu du corps du modele",
        sample_media: "Media d'exemple",
        sample_media_help:
          "Chargez l'image, le document ou la video que Meta examinera avec ce modele.",
        sample_media_limits:
          "Images: JPEG/PNG jusqu'a 5 Mo. Videos: MP4/3GP jusqu'a 16 Mo. Les GIF doivent etre charges sur des modeles VIDEO et convertis en MP4 par le backend quand c'est active.",
        sample_media_ready:
          "Le media d'exemple est charge et pret pour la soumission.",
        sample_media_video_help:
          "Chargez une video MP4/3GP. Les GIF sont acceptes seulement si la conversion backend vers MP4 est activee.",
        save_appeal: "Enregistrer",
        save_draft: "Brouillon",
        saved: "Modele enregistre",
        search: "Rechercher",
        search_placeholder: "Recu, livraison, code...",
        sender: "Expediteur",
        status: "Statut",
        submit: "Soumettre",
        submitted: "Modele soumis",
        summary: "%{approved} approuves sur %{total} modeles",
        sync: "Synchroniser",
        sync_all: "Synchroniser depuis Meta",
        sync_all_done: "Modeles synchronises depuis Meta",
        sync_status: "Synchroniser le statut",
        synced: "Modele synchronise",
        add_quick_reply: "Ajouter reponse",
        add_url_button: "Ajouter URL",
        no_template_buttons: "Aucun bouton ajoute.",
        remove_button: "Retirer le bouton",
        template_buttons: "Boutons",
        template_buttons_help:
          "Utilisez les reponses rapides pour Create my movie et Stop promotions; ajoutez une URL HTTPS statique si besoin.",
        button_slash_help:
          'Une reponse rapide renvoie son propre libelle a Felix : le libelle EST la commande. La barre oblique est facultative — Felix lit "/create" et "Create" de la meme facon ; ce qui compte est que la formulation lui soit connue.',
        title: "Modeles WhatsApp",
        topic: "Sujet",
        unpause: "Reprendre",
        unpaused: "Modele repris",
        updated: "Mis a jour",
        usecase: "Usage",
        zero_tap_terms: "Conditions zero-tap acceptees",
      },
      broadcasts: {
        actions: "Actions",
        add_pasted_ids: "Ajouter les IDs",
        advanced_contact_ids: "Coller des IDs contacts",
        all_matching_selected:
          "%{smart_count} contact correspondant selectionne |||| %{smart_count} contacts correspondants selectionnes",
        all_matching_selected_more:
          "%{count}+ contacts correspondants selectionnes",
        clear_selection: "Effacer",
        contact: "Contact",
        contact_ids: "IDs contacts",
        created: "Cree",
        created_success: "Diffusion creee",
        edit: "Modifier la diffusion",
        edit_action: "Modifier",
        edited: "Modifiee le %{date}",
        edit_blocked_hint:
          "Seule une diffusion programmee dont l'envoi n'a pas commence peut etre modifiee.",
        empty: "Aucune diffusion WhatsApp",
        error: "Erreur",
        name: "Nom",
        name_placeholder: "Promo, rappel de renouvellement...",
        live_preview: "Rendu du message",
        live_preview_empty: "Choisissez un modele pour voir le message.",
        live_preview_missing: "Non renseigne : %{placeholders}",
        message_preview: "Apercu du message",
        header_media: "Image d'en-tete",
        header_media_use_template: "Utiliser l'image du modele",
        header_media_upload_different: "Telecharger une autre image",
        header_media_from_template:
          "Image du modele utilisee. C'est ce que les destinataires recevront.",
        header_media_template_unsendable:
          "Ce modele a ete importe sans image stockee. Telechargez-en une pour l'utiliser dans une diffusion.",
        header_media_dropzone: "Glissez une image ici, ou cliquez pour choisir",
        header_media_dropzone_hint: "%{noun} · jusqu'a %{limit}",
        header_media_uploading: "Telechargement…",
        header_media_format_mismatch:
          "Ce type de fichier n'est pas autorise pour ce modele.",
        header_media_too_large:
          "Ce fichier est trop volumineux (max %{limit}).",
        eligibility_unknown: "Inconnu",
        explicit_selected:
          "%{smart_count} contact selectionne |||| %{smart_count} contacts selectionnes",
        hidden_selected:
          "%{smart_count} selectionne hors de cette page |||| %{smart_count} selectionnes hors de cette page",
        missing_whatsapp_id: "Sans WhatsApp",
        more_previews: "+%{count} autres",
        matching_contacts:
          "%{smart_count} contact correspond aux filtres |||| %{smart_count} contacts correspondent aux filtres",
        matching_contacts_excluded:
          "%{smart_count} contact correspondant exclu |||| %{smart_count} contacts correspondants exclus",
        matching_contacts_more: "%{count}+ contacts correspondent aux filtres",
        new: "Nouvelle diffusion",
        next_page: "Page suivante",
        no_contacts: "Aucun contact trouve",
        opted_out: "Desinscrit",
        page_count: "Page %{page}",
        paste_contact_ids: "contact_123, contact_456",
        previous_page: "Page precedente",
        preview: "Apercu",
        progress: "Progression",
        recipient_search: "Trouver des destinataires",
        recipient_search_placeholder: "Rechercher des contacts",
        recipients: "Destinataires",
        compliance_attestation:
          "Je confirme que ces destinataires ont consenti et que cette diffusion respecte la politique WhatsApp Business.",
        include_not_opted_in_label:
          "Inclure les contacts sans consentement enregistre",
        include_not_opted_in_hint:
          "Envoie aussi aux contacts dont le consentement est inconnu. Les contacts desinscrits sont toujours exclus.",
        included_without_opt_in: "%{count} sans consentement enregistre",
        insert_variable: "Variable",
        missing_variable_hint:
          "%{count} destinataires ignores : une variable de personnalisation n'a pas de valeur pour eux ni de texte de repli. Ajoutez un repli apres le | du jeton pour les inclure.",
        variables: {
          portal_url: "Lien suivi vers le portail",
          rated_echo_title: "Titre de l'Echo note",
          latest_echo_title: "Titre du dernier Echo",
          first_name: "Prenom",
          last_rating: "Derniere note",
        },
        send_blocked_not_opted_in_hint:
          '%{count} destinataires n\'ont pas de consentement enregistre et sont ignores. Cochez "Inclure les contacts sans consentement enregistre" ci-dessus pour les inclure (les contacts desinscrits restent exclus).',
        schedule: "Programmer",
        scheduled_for: "Programme pour",
        scheduled_for_short: "Programme %{date}",
        selected_contacts:
          "%{smart_count} contact selectionne |||| %{smart_count} contacts selectionnes",
        select_all_matching: "Tout selectionner",
        select_page: "Selectionner la page",
        send_later: "Envoyer plus tard",
        send_mode: "Mode d'envoi",
        send_now: "Envoyer maintenant",
        send: "Envoyer",
        save_changes: "Enregistrer les modifications",
        status: "Statut",
        summary: "%{total} diffusions",
        template: "Modele",
        title: "Diffusions WhatsApp",
        updated: "Mis a jour",
        updated_success: "Diffusion mise a jour",
        whatsapp_ready: "Pret",
        cohort: {
          title: "Cohortes d'audience",
          echo_activity: "Activite Echo",
          lifecycle: "Etape du cycle de vie",
          uses: "Utilisations",
          videos: "Echos termines",
          satisfaction: "Etoiles moyennes",
          geography: "Geographie",
          recency: "Recence",
          reachability: "Joignabilite",
          acquisition: "Source d'acquisition",
          acquisition_website: "🌐 Site web",
          acquisition_ctwa: "💬 Meta → WhatsApp",
          acquisition_organic: "🌱 Organique",
          acquisition_snap: "📸 Snap (borne Instax)",
          acquisition_link: "🔗 Lien de suivi",
          acquisition_launchpad: "🚀 Launchpad",
          acquisition_my_web: "💻 Web My Echoflicks",
          language: "Langue",
          language_any: "Langue : %{language}",
          include: "Inclure",
          exclude: "Exclure",
          explicit_geo_disabled: "Contacts individuels selectionnes",
          broadcast_to_segment: "Diffuser a ce segment",
          selected_segment: "Segment de cohorte",
          continent_AF: "Afrique",
          continent_AS: "Asie",
          continent_EU: "Europe",
          continent_NA: "Amerique du Nord",
          continent_OC: "Oceanie",
          continent_SA: "Amerique du Sud",
          continent_UNKNOWN: "Inconnu",
          geo_continents_any: "Continents : %{continents}",
          geo_continents_none: "Exclure : %{continents}",
          geo_countries_any: "Pays : %{countries}",
          geo_countries_none: "Exclure pays : %{countries}",
          geo_overlap:
            "Un continent ne peut pas etre inclus et exclu dans la meme diffusion.",
          lifecycle_prospect: "Prospect",
          lifecycle_abandoned_photos: "Abandon aux photos",
          lifecycle_abandoned_story: "Abandon au recit",
          lifecycle_abandoned_director: "Abandon au realisateur",
          lifecycle_generating: "Generation",
          lifecycle_failed: "Echec",
          lifecycle_delivered_once: "Livre une fois",
          lifecycle_repeat: "Createur recurrent",
          echo_today: "Echo aujourd'hui",
          echo_this_week: "Echo cette semaine",
          echo_before_this_week: "Pas d'Echo cette semaine",
          echo_before_this_month: "Pas d'Echo ce mois",
          echo_before_last_month: "Inactif depuis le mois dernier",
          uses_0: "Aucune utilisation",
          uses_1: "1 utilisation",
          uses_2to4: "2-4 utilisations",
          uses_5plus: "5+ utilisations",
          videos_0: "Aucune video",
          videos_1: "1 video",
          videos_2plus: "2+ videos",
          average_rating_champion: "Champions (4.5+)",
          average_rating_happy: "Satisfaits (3.5-4.49)",
          average_rating_mixed: "Mitiges (2.5-3.49)",
          average_rating_unhappy: "Insatisfaits (<2.5)",
          average_rating_none: "Aucune note",
          rating_promoter: "Promoteurs (4-5)",
          rating_passive: "Passifs (3)",
          rating_detractor: "Detracteurs (1-2)",
          rating: "Derniere note",
          rating_stars: "Note %{stars} ★",
          rating_unrated: "Sans note",
          explicit_rating_disabled: "Contacts individuels selectionnes",
          active_within_days: "Actif sous %{days}j",
          dormant_beyond_days: "Inactif depuis %{days}j",
          window_open: "Fenetre 24h ouverte",
          window_closed: "Fenetre fermee (modele)",
          reachable: "Joignable maintenant",
          reachable_only: "Joignables uniquement",
          messaging_window: "Fenetre de message",
          messaging_window_any: "Toute fenetre",
          messaging_window_open: "Libre ouvert",
          messaging_window_closed: "Modele requis",
          refine: "Affiner la joignabilite",
          opted_in: "Inscrit",
          summary: "Cohorte : %{summary}",
          eligible_of_total: "%{eligible} eligibles sur %{total}",
          scanned: "%{count} analyses",
          pages: "%{count} pages",
          incomplete: "Analyse incomplete",
          computed_at:
            "Calcule a %{time}; fenetre et recence refletent ce moment.",
          skip_reason_missing_whatsapp_user_id: "Identite WhatsApp manquante",
          skip_reason_opted_out: "Desinscrit",
          skip_reason_duplicate_whatsapp_user_id: "Contact WhatsApp duplique",
          detractor_marketing_warning:
            "Certains destinataires sont detracteurs. Preferer un modele UTILITY de recuperation.",
        },
      },
      analytics: {
        title: "Analyse de diffusion",
        not_enabled:
          "L'analyse de diffusion n'est pas encore activee pour cet environnement.",
        view: "Voir l'analyse",
        read_help:
          "Lu correspond a un accuse de lecture WhatsApp, pas a une ouverture garantie.",
        inferred_help: "Deduit apres la fenetre configuree.",
        cost_title: "Cout",
        total_spend: "Depense totale",
        cost_per_delivered: "Cout par message delivre",
        cost_per_reply: "Cout par reponse",
        billable_messages: "Messages facturables",
        cost_unavailable: "Donnees de cout indisponibles",
        clicks_title: "Clics sur le modele",
        clicked_url_button: "Clics bouton URL",
        clicked_quick_reply: "Clics reponse rapide",
        template_analytics_unavailable:
          "L'analyse des clics du modele est indisponible.",
        reply: "Reponse",
        open_conversation: "Ouvrir la conversation",
        pricing_category: "Categorie de tarification",
        unavailable: "Indisponible",
      },
    },
    changelog: {
      title: "Notes de version",
    },
    lab_results: {
      nav: "Résultats du labo",
      title: "Résultats du labo",
      subtitle:
        "Revue côte à côte des expériences du labo : mêmes entrées, traitements différents, pleine résolution.",
      empty: "Aucun résultat d'expérience publié pour le moment.",
      load_error: "Impossible de charger les résultats",
      not_found: "Cette expérience n'existe pas (ou a été dépubliée).",
      back: "Tous les résultats",
      photos: "%{smart_count} photo |||| %{smart_count} photos",
      arms: "%{smart_count} variante |||| %{smart_count} variantes",
      legend: "Ce que vous regardez",
      pick_photo: "Choisissez une photo (touches ← → aussi)",
      view_compare: "Côte à côte",
      view_wipe: "Balayage",
      view_grid: "Grille",
      open_full: "Ouvrir en pleine résolution",
      metrics: "Mesures",
      arm: "Variante",
      wipe_left: "Gauche",
      wipe_right: "Droite",
      wipe_slider: "Position du balayage",
      wipe_help:
        "Déplacez le curseur ou glissez sur l'image pour révéler la variante de droite.",
      zoom_100: "Voir à 100 %",
      zoom_fit: "Ajuster à l'écran",
      lightbox_help: "← → variantes · ↑ ↓ photos · Z zoom · Échap fermer",
      videos: "%{smart_count} film |||| %{smart_count} films",
      pick_video: "Choisissez un film (touches ← → aussi)",
      play_both: "Lire les deux",
      pause_both: "Pause",
      restart: "Revenir au début",
      seek: "Position dans les deux films",
      listen: "Écouter",
      listening: "À l'écoute",
      sync_help:
        "Les deux films avancent ensemble et un seul est audible : changez le son avec les boutons Écouter ou les touches 1 / 2 pour comparer les bandes-son à la même image. Espace lit et met en pause.",
      gallery_help:
        "Tout est sur cette page. Lancez n'importe quel extrait ; les autres se mettent en pause.",
      playground: {
        tab: "Atelier",
        title: "Générer avec cette recette",
        subtitle:
          "Rendez une photo avec le LoRA et les prompts de cette entrée sur nos propres GPU. Faites varier l'intensité pour voir l'effet.",
        status_unknown: "Vérification du GPU…",
        status_ready: "GPU prêt · %{gpu}",
        status_rendering: "GPU en cours de rendu atelier · %{gpu}",
        status_production: "GPU occupé par un rendu de production · %{gpu}",
        status_offline:
          "GPU hors ligne : les générations attendent le retour d'une tour",
        status_error: "État du GPU indisponible",
        input: "Photo",
        input_photo_hint:
          "Choisissez une autre photo dans la bande ci-dessus, ou importez la vôtre.",
        input_upload_hint:
          "Votre import. Revenez à la photo de l'entrée à tout moment.",
        upload: "Importer",
        use_entry_photo: "Utiliser la photo de l'entrée",
        upload_failed: "Échec de l'import",
        lora: "LoRA",
        prompt: "Prompt",
        custom: "Personnalisé",
        custom_hint:
          "{trigger} et {gear} sont remplacés par les mots déclencheurs du LoRA. <image1> est votre photo.",
        strength: "Intensité",
        strength_less: "%{value} · plus subtil, plus net",
        strength_more: "%{value} · rendu plus marqué, plus doux",
        no_lora_hint:
          "Sans LoRA : la photo est seulement re-rendue avec le prompt, l'intensité n'a pas d'effet.",
        seed: "Graine",
        seed_published: "Comme publié",
        seed_published_missing: "Uniquement pour les photos de l'entrée",
        seed_random: "Aléatoire",
        seed_fixed: "Fixe",
        seed_hint:
          "Même photo + même graine + mêmes réglages = même image. Ne changez que l'intensité pour comparer.",
        generate: "Générer",
        sweep: "Balayage d'intensité (%{values})",
        production_first:
          "Tourne sur nos tours GPU. Les rendus de production passent toujours en premier : une génération peut attendre quelques minutes.",
        generate_failed: "Impossible de lancer la génération",
        empty:
          "Vos générations s'affichent ici. Choisissez une photo, réglez l'intensité et cliquez sur Générer.",
        state_queued: "En file",
        state_waiting_gpu: "En attente du GPU",
        state_waiting_production:
          "En attente de la fin d'un rendu de production",
        state_running: "Rendu en cours",
        state_done: "Terminé",
        state_failed: "Échec",
        state_cancelled: "Annulé",
        state_stalled: "Le worker GPU ne répond plus",
        elapsed: "%{seconds} s",
        cancel: "Annuler",
        no_lora: "Sans LoRA",
        strength_value: "Intensité %{value}",
        seed_value: "graine %{seed}",
        timing: "%{render} s de rendu · %{wait} s d'attente du GPU",
        before: "Avant",
        after: "Après",
        wipe: "Position avant/après",
        open_full: "Ouvrir en taille réelle",
        history: "Générations de cette entrée",
        history_error: "Impossible de charger les générations",
        history_empty: "Rien de généré pour l'instant.",
      },
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'affaire",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'affaire",
      added_deal: "%{name} a ajouté l'affaire",
      you_added_deal: "Vous avez ajouté l'affaire",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des affaires à venir",
      deals_pipeline: "Pipeline des affaires",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      stepper: {
        install: "Installer Echoflicks CRM",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    header: {
      import_data: "Importer des données",
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    import: {
      action: {
        download_error_report: "Téléchargez le rapport d'erreur",
        import: "Importer",
        import_another: "Importer un autre fichier",
      },
      error: {
        unable: "Impossible d'importer ce fichier.",
      },
      idle: {
        description_1:
          "Vous pouvez importer des ventes, des entreprises, des contacts, des entreprises, des notes et des tâches.",
        description_2:
          "Les données doivent se trouver dans un fichier JSON correspondant à l'exemple suivant :",
      },
      status: {
        all_success: "Tous les enregistrements ont été importés avec succès.",
        complete: "Importation terminée.",
        failed: "Échoué",
        imported: "Importé",
        in_progress: "Import en cours, veuillez ne pas quitter cette page.",
        some_failed: "Certains enregistrements n'ont pas été importés.",
        table_caption: "Statut d'importation",
      },
      title: "Importer des données",
    },
    settings: {
      about: "À propos",
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'affaire à considérer comme des affaires dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        stages: "Étapes",
      },
      light_mode_logo: "Logo du mode clair",
      notes: {
        statuses: "Statuts",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      sections: {
        branding: "Image de marque",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés par des affaires : %{items}",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    language: "Langue",
    navigation: {
      label: "Navigation CRM",
      home: "Accueil",
      more: "Plus",
      chat: "Chat",
      more_description: "Tous les autres espaces, regroupés par équipe.",
    },
    profile: {
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Echoflicks CRM traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
      },
      password: {
        change: "Changer le mot de passe",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
  },
} satisfies CrmMessages;
